module.exports = "/_next/static/images/22e35ed02f9f7caec1d4b7567e1763ea-graphic-icon.svg";